import { render, staticRenderFns } from "./task-detail-pannel.vue?vue&type=template&id=21be48e6&scoped=true&"
import script from "./task-detail-pannel.vue?vue&type=script&lang=js&"
export * from "./task-detail-pannel.vue?vue&type=script&lang=js&"
import style0 from "./task-detail-pannel.vue?vue&type=style&index=0&id=21be48e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be48e6",
  null
  
)

export default component.exports